import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { addPageHeadSettings } from 'utils/addPageHeadSettings';
import { initSentry } from 'utils/sentry';
import { initTalkMe } from 'utils/talkMe';
import { env_externalservices, env_commit, NODE_ENV } from 'env';
import { configureStore } from 'store';
import Routes from 'routes';
import 'styles/global';
import { BrowserSupport } from 'components/common/BrowserSupport';

if (NODE_ENV === 'production' && env_externalservices === 'true') {
  initSentry({
    dsn: 'https://4bc46cf771194eff946ea4b39ecc3fde@o586667.ingest.sentry.io/5738322',
    release: env_commit || 'localhost',
    ignoreErrors: [
      'Network request failed',
      'Network Error',
      'A network error (such as timeout, interrupted connection or unreachable host) has occurred.',
      'NetworkError when attempting to fetch resource.',
      'Failed to fetch',
      'Request aborted',
      'Unauthorized access',
      'Submit Validation Failed',
      'Request failed with status code',
      'Request failed',
      'timeout of 0ms exceeded',
    ],
  });
}

if (env_externalservices === 'true') {
  initTalkMe();
}

if (env_externalservices === 'true' && NODE_ENV !== 'test') {
  import('utils/metrics')
    .then(({ default: Metrics }) => {
      Metrics.init({
        mixpanelToken: '359a94312382e022102ecbb4e5c52867',
        release: env_commit || 'localhost',
        domain: window.location.origin,
        debug: NODE_ENV !== 'production',
        env: NODE_ENV,
      });
      const userId = localStorage.getItem('USER_ID');
      if (userId) Metrics.identify(userId);
    })
    .catch(() => undefined);
}

addPageHeadSettings();

const store = configureStore();

const renderApp = (Component) => (
  <BrowserSupport>
    <HelmetProvider>
      <Provider store={store}>
        <Component />
      </Provider>
    </HelmetProvider>
  </BrowserSupport>
);

const rootElement = document.getElementById('root');

const root = createRoot(rootElement);
root.render(renderApp(Routes));

if (import.meta.hot) {
  import.meta.hot.accept('./routes', (module) => {
    if (module) root.render(renderApp(module.default));
  });
}
